import { render, staticRenderFns } from "./SupplierBrandMaintenance.vue?vue&type=template&id=329f7539&scoped=true&"
import script from "./SupplierBrandMaintenance.vue?vue&type=script&lang=js&"
export * from "./SupplierBrandMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329f7539",
  null
  
)

export default component.exports